import { createReducer, on } from '@ngrx/store';
import { AdvancedFiltersActions } from '../actions';
import { AdvancedFilter } from '@app/sharedModule/models/advanced-filter.model';

export const featureKey = 'advanced-filters';

export interface State {
  filters: AdvancedFilter[];
  countReadyOrders: number;
  countHoldOrders: number;
  countScheduleOrders: number;
}

export const initialState: State = {
  filters: null,
  countReadyOrders: null,
  countHoldOrders: null,
  countScheduleOrders: null,
};

export const reducer = createReducer(
  initialState,
  on(AdvancedFiltersActions.refreshAdvancedFiltersSuccess, (state: State, { advancedFilters }) => ({
    ...state,
    filters: !state.filters
      ? advancedFilters
      : advancedFilters.map((advancedFilter: AdvancedFilter) => {
          const existing = state.filters.find((item: AdvancedFilter) => item.id === advancedFilter.id);
          return !existing ? advancedFilter : { ...existing, ...advancedFilter };
        }),
  })),
  on(AdvancedFiltersActions.changeCountOrderInFilter, (state: State, { filterId, countOrder }) => ({
    ...state,
    filters: state.filters.map((filter: AdvancedFilter) =>
      filter.id !== filterId ? filter : { ...filter, resultCount: countOrder },
    ),
  })),
  on(AdvancedFiltersActions.loadCountReadyOrdersSuccess, (state: State, { countReadyOrders }) => ({
    ...state,
    countReadyOrders,
  })),
  on(AdvancedFiltersActions.changeCountReadyOrders, (state: State, { countReadyOrders }) => ({
    ...state,
    countReadyOrders,
  })),
  on(AdvancedFiltersActions.loadCountHoldOrdersSuccess, (state: State, { countHoldOrders }) => ({
    ...state,
    countHoldOrders,
  })),
  on(AdvancedFiltersActions.changeCountHoldOrders, (state: State, { countHoldOrders }) => ({
    ...state,
    countHoldOrders,
  })),
  on(AdvancedFiltersActions.loadCountScheduleOrdersSuccess, (state: State, { countScheduleOrders }) => ({
    ...state,
    countScheduleOrders,
  })),
  on(AdvancedFiltersActions.changeCountScheduleOrders, (state: State, { countScheduleOrders }) => ({
    ...state,
    countScheduleOrders,
  })),
  on(AdvancedFiltersActions.deleteAdvancedFilterSuccess, (state: State, { filterId }) => ({
    ...state,
    filters: state?.filters.filter((filter: AdvancedFilter) => filter.id !== filterId),
  })),
);

export const getFilters = (state: State): AdvancedFilter[] => state.filters;
export const getCountReadyOrders = (state: State): number => state.countReadyOrders;
export const getCountHoldOrders = (state: State): number => state.countHoldOrders;
export const getCountScheduleOrders = (state: State): number => state.countScheduleOrders;
